import { render } from "./MGWalkthrough.vue?vue&type=template&id=38268865&scoped=true"
import script from "./MGWalkthrough.vue?vue&type=script&lang=js"
export * from "./MGWalkthrough.vue?vue&type=script&lang=js"

import "./MGWalkthrough.vue?vue&type=style&index=0&id=38268865&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38268865"]])

export default __exports__